module.exports = __webpack_public_path__ + "img/example2.f262f4a.png";